import "core-js/modules/es6.function.name";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  isEdit: function isEdit(state) {
    return state.settings.isEdit;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  menuList: function menuList(state) {
    return state.user.menuList;
  },
  marginStatus: function marginStatus(state) {
    return state.user.marginStatus;
  },
  marginDays: function marginDays(state) {
    return state.user.marginDays;
  },
  merCateList: function merCateList(state) {
    return state.product.merCateList;
  },
  merProductLabelList: function merProductLabelList(state) {
    return state.product.merProductLabelList;
  },
  sysCateList: function sysCateList(state) {
    return state.product.sysCateList;
  },
  storeTypeList: function storeTypeList(state) {
    return state.product.storeTypeList;
  }
};
export default getters;